var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.34796L8.67085 0L7.10972 1.56113L0 8.65204V12H3.34796L10.7022 4.66458L12 3.34796ZM10.9486 3.34838L10.1587 4.13835L7.88281 1.84368L8.65397 1.05371L10.9486 3.34838ZM0.75 9.72461L2.31113 11.2481H0.75V9.72461ZM3.19629 11.0783L0.882812 8.82127L7.33422 2.38867L9.62889 4.66453L3.19629 11.0783Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.43b6aca8e8ffc6422c9d72b431c35ed6.svg";
export { ForwardRef as ReactComponent };